import { ActivityProduct } from './../activity.models';
export class RegistrationStateModel {
  saved: boolean;
  registration?: Registration;
}

export class Registration {
  confirmationText?: string;
  url: string;
  registrationDeadline?: Date;
  formControls: RegistrationFormControl[];
  productPackages?: ProductPackage[];
}

export class RegistrationFormControl {
  id: string;
  title: string;
  description: string;
  url?: string;
  type: string;
  required: boolean;
  locked: boolean;
  important: boolean;
  options?: string[];
}

export class ProductPackage {
  id: string;
  name: string;
  products: ProductPackageProduct[];
}

export class ProductPackageProduct extends ActivityProduct {
  isEditable: boolean;
}
